import React from 'react'
import { connect } from 'react-redux'
import View from './View'
import { getInnovateIdeaTemplateIdJson, getInitialInnovateIdeaDraft ,postInnovateCreateIdeaDraft,postInnovateCreateIdeaEdit} from 'services/innovate/idea'
// import { postIdeaDocument,deleteIdeaDocument } from 'services/create_idea'
import { getBase64Split } from 'support/utils/file'
import Navigation from 'support/navigation'
import {
  showPopupDialog,
  showPopupErrorSnackbar,
  showPopupSuccessSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './dialogs/ErrorSubmitContainer'
import SuccessSubmitModal from './dialogs/SucessSubmitContainer'
import ConfirmSubmitModal from './dialogs/ConfirmSubmitContainer'

import i18n from 'support/i18n'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { MAX_SIZE_DOCUMENT } from 'common_constants/Ideas'
import { deleteInnovateIdeaDocument, postInnovateIdeaDocument,deleteInnovateIdeaImage, postInnovateIdeaImage  } from 'services/innovate/idea'



const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  getInnovateIdeaTemplateIdJsonLoading: state.data.InnovateIdea.getInnovateIdeaTemplateIdJsonLoading,
  getInnovateIdeaTemplateIdJson:state.data.InnovateIdea.getInnovateIdeaTemplateIdJson,
  getInnovateIdeaDraftID:state.data.InnovateIdea.getInnovateIdeaDraftID,
  getInnovateCreateIdeaDraftData:state.data.InnovateIdea.getInnovateCreateIdeaDraftData,
  getInnovateCreateIdeaDraftLoading:state.data.InnovateIdea.getInnovateCreateIdeaDraftLoading,
  getInnovateIdeaDocumentUploadListLoading:state.data.InnovateIdea.getInnovateIdeaDocumentUploadLoading,
  deleteInnovateIdeaDocumentLoading:state.data.InnovateIdea.deleteInnovateIdeaDocumentLoading,
  getInnovateIdeaDocumentUploadList:state.data.InnovateIdea.getInnovateIdeaDocumentUpload,
  deleteInnovateIdeaDocument:state.data.InnovateIdea.deleteInnovateIdeaDocument,
  getInnovateIdeaImageLoading:state.data.InnovateIdea.getInnovateIdeaImageLoading,
  getInnovateIdeaImage:state.data.InnovateIdea.getInnovateIdeaImage,
  getInnovateIdeaImageDeleteLoading:state.data.InnovateIdea.getInnovateIdeaImageDeleteLoading,
  getInnovateCreateIdeaPublishLoading:state.data.InnovateIdea.getInnovateCreateIdeaPublishLoading,
  
  isAdmin: state.data.user.admin,
  isInnovator: state.data.user.isInnovator,
  isEvaluator: state.data.user.evaluator,
  // isOwnerInnovate: state.data.InnovateIdea.getInnovateIdeaDraftID.owner === state.data.user.userEmail,
  isOwner: state.data.createIdea.owner === state.data.user.userEmail,
  csrf:state.auth.csrf,

})

const mapDispatchToProps = dispatch => {
  return {
    
    getInitialInnovateIdeaDraftFn: ()=>{
      dispatch(getInitialInnovateIdeaDraft())
    },
    getInnovateIdeaTemplateIdJsonFn: (idIdeaTemplate)=>{
      dispatch(getInnovateIdeaTemplateIdJson(idIdeaTemplate))
    },
    postInnovateCreateIdeaDraftFn: (idIdeaTemplate)=>{
      const onSuccess = data => {
        const message=i18n.t('DRAFTIDEA')
        showPopupSuccessSnackbar(message, dispatch)
        dispatch(Navigation.navigateToInnovateIdea(data.idea.id))
      }
      const onFailure = ({ data }) => {
        if (data && data.error && data.error.status === 400 && data.error.code === 2070) {
          showPopupErrorSnackbar('Please uplodad the image for Idea.', dispatch)
        } else {
          showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
        }
      
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorSubmitModal description={i18n.t(messageTag)} />, dispatch)
      }
      dispatch(postInnovateCreateIdeaDraft(idIdeaTemplate, onSuccess, onFailure))
    }, 
    postInnovateCreateIdeaPublishFn: (idIdeaTemplate)=>{
      // console.log("createInnovateIdeaData--",idIdeaTemplate)
      // dispatch(idIdeaTemplate))
      showPopupDialog(<ConfirmSubmitModal createInnovateIdeaData={idIdeaTemplate}  />, dispatch)
    }, 
    postInnovateCreateIdeaEditFn: (idIdeaTemplate)=>{
      dispatch(postInnovateCreateIdeaEdit(idIdeaTemplate))
    },
    
    handleDocumentUploadLogic : (id, file, documentKey) => {
      if (!file) return;
    
      const onSuccess = () => {
        showPopupSuccessSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_COMPLETE'), dispatch);
        dispatch(hideDialog());
      };
    
      const onFailure = (error) => {
        if (error?.status === 413) {
          showPopupErrorSnackbar(
            i18n.t('EXPLORE_IDEA.UPLOAD_MAX_SIZE_DOC_ERROR', { max_size: MAX_SIZE_DOCUMENT }),
            dispatch
          );
        } else {
          showPopupErrorSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_ERROR'), dispatch);
        }
        dispatch(hideDialog());
      };
    
      getBase64Split(
        file,
        (fileName, base64File) => {
          dispatch(postInnovateIdeaDocument(id, fileName, documentKey, base64File, onSuccess, onFailure));
        },
        true
      );
    },
    
    onDocumentUpload: (id,file,documentKey) => {
      const onSuccess = () => {
        showPopupSuccessSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_COMPLETE'), dispatch)
        dispatch(hideDialog())
      }
      const onFailure = error => {
        if (error.status === 413) {
          showPopupErrorSnackbar(
            i18n.t('EXPLORE_IDEA.UPLOAD_MAX_SIZE_DOC_ERROR', { max_size: MAX_SIZE_DOCUMENT }),
            dispatch,
          )
        } else {
          showPopupErrorSnackbar(i18n.t('EXPLORE_IDEA.UPLOAD_DOC_ERROR'), dispatch)
        }
        dispatch(hideDialog())
      }
      getBase64Split(
        file,
        (fileName, base64File) => {
          dispatch(postInnovateIdeaDocument(id,fileName, documentKey,base64File, onSuccess, onFailure))
        },
        true,
      )
    },
    onDocumentDelete: (id, documentId) => {
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('EXPLORE_IDEA.DELETE_KO'), dispatch)
      }
      dispatch(deleteInnovateIdeaDocument(id, documentId, onFailure))
    },
   
    

  postInnovateIdeaImageFn : (IdKeyForImage,imageName)=>{
      const onSuccess = () =>{}
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
      }
      dispatch(postInnovateIdeaImage(IdKeyForImage,imageName, onSuccess, onFailure))
    },
    deleteImageFn: (ideaID,imageName) => {
      const onFailure = errorResponse => {
        const { data } = errorResponse
        if (data && data.error && data.error.status === 400 && data.error.code === 2003) {
          showPopupErrorSnackbar(i18n.t('CHALLENGES.DELETE_IMAGE_ERROR'), dispatch)
        } else {
          showPopupErrorSnackbar(i18n.t('BACKEND_ERRORS.UNEXPECTED'), dispatch)
        }
      }
      dispatch(deleteInnovateIdeaImage(ideaID,imageName, onFailure))
    },


  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
